import { getString } from "../../common/common";

export const OB_REF_NUM = 'Enter_OB_Reference_Number';
export const OB_REF_GEN = 'Enter_the_OB_Reference_No._generated_during_booking';
export const NO_RECENT_BOOKING = 'You_have_no_recent_bookings.';

export const MOB_NUM = "Enter_Mobile_Number";
export const MOB_NUM_ERR = "Enter_valid_mobile_no";
export const ENTER_OTP = "ENTER_OTP";
export const VERIFY = "VERIFY";
export const RESEND_OTP_IN = "RESEND_OTP_IN";
export const RESEND_OTP_NOW = "RESEND_OTP_NOW";
export const ENTER_VALID_OTP = "ENTER_VALID_OTP";


export const translations = {
    en: {
        [OB_REF_NUM]: "Enter the OB Reference Number",
        [OB_REF_GEN]: "Enter the OB Reference No. and mobile no generated during booking",
        [NO_RECENT_BOOKING]: "You have no recent bookings.",
        [MOB_NUM]: "Enter Mobile Number",
        [MOB_NUM_ERR]: "Enter valid mobile no",
        [ENTER_OTP]: "Enter OTP (One Time Password) ",
        [VERIFY]: "Verify",
        [RESEND_OTP_IN]: "Resend Otp in ",
        [RESEND_OTP_NOW]: "Resend the OTP now",
        [ENTER_VALID_OTP]: "Please enter Valid otp",
    },
    kn: {
        [OB_REF_NUM]: "OB ರೆಫರೆನ್ಸ್ ನಂಬರ್ ಎಂಟರ್ ಮಾಡಿ",
        [OB_REF_GEN]: "ಬುಕಿಂಗ್ ಸಮಯದಲ್ಲಿ ರಚಿಸಲಾದ OB ರೆಫರೆನ್ಸ್  ನಂಬರ್ ಎಂಟರ್ ಮಾಡಿ",
        [NO_RECENT_BOOKING]: "ನೀವು ಯಾವುದೇ ಇತ್ತೀಚಿನ ಬುಕಿಂಗ್‌ಗಳನ್ನು ಹೊಂದಿಲ್ಲ.",
        [MOB_NUM]: "ಮೊಬೈಲ್ ನಂಬರ್ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",
        [MOB_NUM_ERR]: "ಸರಿಯಾದ ಮೊಬೈಲ್ ನಂಬರ್ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",
        [ENTER_OTP]: "OTP (ಒನ್ ಟೈಮ್ ಗುಪ್ತಪದ) ಎಂಟರ್ ಮಾಡಿ",
        [VERIFY]: "ಪರಿಶೀಲಿಸಿ",
        [RESEND_OTP_IN]: "OTP ಅನ್ನು ಮತ್ತೆ ಕಳುಹಿಸಿ",
        [RESEND_OTP_NOW]: "ಈಗ OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
        [ENTER_VALID_OTP]: "ದಯವಿಟ್ಟು ಸರಿಯಾದ OTPಯನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    },
};

export const t = (key = "") => {
    return getString(key, translations)
}